import { type DateInput, format } from '@formkit/tempo';

export const formatToUKDate = (inputDate: DateInput | undefined, showTime: boolean | undefined = false, tz: string | undefined = 'UTC'): string | undefined => {
    return inputDate ? format({
        date: inputDate,
        format: showTime ? 'DD.MM.YYYY HH:mm:ss' : 'DD.MM.YYYY',
        tz: !showTime ? tz : undefined
    }) : undefined;
};
